import {
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    WithFieldValue,
    SnapshotOptions,
    PartialWithFieldValue,
    DocumentData,
    SetOptions, Timestamp
} from "firebase/firestore";
import {AppInfo, OrderInfo} from "../reducks/info/types";
import {Product} from "../reducks/products/types";

import {Order} from "../reducks/orders/types";
import {Category} from "../reducks/categories/types";

function assertProduct(data: any): asserts data is Product {
    const d = data as Partial<Product>; // 補完のためキャスト
    if (
        !(
            typeof d?.id === "string" &&
            typeof d?.category === "string" &&
            typeof d?.description === "string" &&
            typeof d?.name === "string" &&
            typeof d?.price === "number"
        )
    ) {
        throw new Error("data is not Product type");
    }
}

function assertOrder(data: any): asserts data is Order {
    const d = data as Partial<Order>; // 補完のためキャスト
    if (
        !(
            typeof d?.id === "string" &&
            typeof d?.amount === "number" &&
            typeof d?.note === "string" &&
            d?.created_at instanceof Timestamp &&
            d?.received_Timestamp instanceof Timestamp &&
            d?.updated_at instanceof Timestamp &&
            d?.products instanceof Array
        )
    ) {
        throw new Error("data is not Order type");
    }
}

function assertOrderInfo(data: any): asserts data is OrderInfo {
    const d = data as Partial<OrderInfo>; // 補完のためキャスト
    if (
        !(
            typeof d?.latestIndex === "number"
        )
    ) {
        throw new Error("data is not OrderInfo type");
    }
}

function assertAppInfo(data: any): asserts data is AppInfo {
    const d = data as Partial<AppInfo>; // 補完のためキャスト
    if (
        !(
            typeof d?.is_maintenance === "boolean" &&
            d?.opening_dates instanceof Array
        )
    ) {
        throw new Error("data is not AppInfo type");
    }
}

function assertCategory(data: any): asserts data is Category {
    const d = data as Partial<Category>; // 補完のためキャスト
    if (
        !(
            typeof d?.id === "string" &&
            typeof d?.name === "string" &&
            typeof d?.order === "string"
        )
    ) {
        throw new Error("data is not AppInfo type");
    }
}

export const productConverter: FirestoreDataConverter<Product> = {
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions | undefined): Product {
        const data = {...snapshot.data(options), id: snapshot.id};
        assertProduct(data);
        return data;
    },
    toFirestore(modelObject: PartialWithFieldValue<Product> | WithFieldValue<Product>): DocumentData {
        delete modelObject.id;
        return modelObject;
    }

}

export const orderConverter: FirestoreDataConverter<Order> = {
    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions | undefined): Order {
        const data = {
            ...snapshot.data(options),
            id: snapshot.id,
        };
        assertOrder(data);
        return data;
    },
    toFirestore(modelObject: PartialWithFieldValue<Order> | WithFieldValue<Order>): DocumentData {
        delete modelObject.id;
        return modelObject;
    }

}

export const orderInfoConverter: FirestoreDataConverter<OrderInfo> = {
    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions | undefined): OrderInfo {
        const data = snapshot.data(options);
        assertOrderInfo(data);
        return data;
    },
    toFirestore(modelObject: WithFieldValue<OrderInfo> | PartialWithFieldValue<OrderInfo>, options?: SetOptions): DocumentData {
        return modelObject;
    }
}

export const appInfoConverter: FirestoreDataConverter<AppInfo> = {
    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions | undefined): AppInfo {
        const data = snapshot.data(options);
        assertAppInfo(data);
        return data;
    },
    toFirestore(modelObject: WithFieldValue<AppInfo> | PartialWithFieldValue<AppInfo>, options?: SetOptions): DocumentData {
        return modelObject;
    }
}

export const categoryConverter: FirestoreDataConverter<Category> = {
    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>, options: SnapshotOptions | undefined): Category {
        const data = snapshot.data(options);
        assertCategory(data);
        return data;
    },
    toFirestore(modelObject: WithFieldValue<Category> | PartialWithFieldValue<Category>, options?: SetOptions): DocumentData {
        return modelObject;
    }
}